<template>
    <!-- Start Main Content -->
    <div v-if="!invoice" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Subscription List</h2>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                      
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Member Name</th>
                                    <th class="bg-[#B2E8D9]">Member Contact</th>
                                    <th class="bg-[#B2E8D9]">Package Name</th>
                                    <!-- <th class="bg-[#B2E8D9]">Cost</th> -->
                                    
                                    <th class="bg-[#B2E8D9]">Start Date</th>
                                    <th class="bg-[#B2E8D9]">End Date</th>
                                    <!-- <th class="bg-[#B2E8D9]">Remark</th> -->
                                    <th class="px-3.5 py-4">Action</th>
                                    
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in subscriptionlist" :key="item.id">
                                    <td>{{item.membername}}</td>
                                    <td>{{item.cell}}</td>
                                    <td>{{item.pkg_name}}</td>
                                    <!-- <td>{{item.cost}}</td> -->
                                    <td>{{ getOnlyDate(item.startdate+"") }}</td>
                                    <td>{{ getOnlyDate(item.enddate+"") }}</td>
                                    <!-- <td>{{item.remark}}</td> -->

                                  
                                    <td class="px-3.5 py-4">
                                        <div class="flex items-center gap-1">
                                            <!-- <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                                <i class="ri-add-line text-danger text-[13px]"></i>
                                            </button> -->
                                            <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" v-show="userRole === '1'">
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
           
                                            <button class="btn-icon btn-primary-icon-light size-7" @click="navigateToPrintPage(item.id)" >
                                              <i class="ri-printer-line text-primary text-[13px]"></i>
                                          </button>
                                            <!-- <button class="btn-icon btn-danger-icon-light size-7" @click="addfollowup(item)">
                                                <i class="ri-edit-2-line text-inherit text-[13px]"></i> -->
                                                 <!-- Change the icon here -->
                                            <!-- </button> -->


                                        </div>
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->


    <!-- start add follow up model -->

  
    <div id="addfollowup" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
          <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
            <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
              <i class="ri-close-line text-inherit text-xl leading-none"></i>
            </button>
            <div class="p-4 md:p-5">
              
                <div class="mt-7">
                    <label for="tagname" class="form-label">Lead Name *</label>
                    <input type="text" v-model="lead.name" class="form-input" id="first_input" placeholder="Lead Name" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Contact *</label>
                    <input type="number" v-model="lead.contact" class="form-input" id="first_input" placeholder="Contact" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Address *</label>
                    <input type="text" v-model="lead.address" class="form-input" id="first_input" placeholder="Address" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Gender *</label>
                    <input type="text" v-model="lead.gender" class="form-input" id="first_input" placeholder="Gender" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Age *</label>
                    <input type="number" v-model="lead.age" class="form-input" id="first_input" placeholder="Age" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Next Date *</label>
                    <input type="date" v-model="lead.nextdate" class="form-input" id="first_input" autocomplete="off" required>
                  </div>
          
                  <div class="mt-7">
                    <label for="tagname" class="form-label">Remark *</label>
                    <input type="text" v-model="lead.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
                  </div>
      
              
      
              <div class="flex justify-end mt-7">
                <button @click="save_package" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      











     <!-- end add follow up model -->







    
  <!-- Start Edit Modal -->
<div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="background: #00000052;">
    <div class="p-4 w-full max-w-lg max-h-full">
      <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square max-h-full overflow-y-auto">
        <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
          <i class="ri-close-line text-inherit text-xl leading-none"></i>
        </button>
        <div class="p-4 md:p-5">
          

           <!-- start show data ---------------------------------------------------------------------------------------->
            <!-- start table here -->
      <div class="p-4 md:p-5">
        <table class="min-w-full table-auto">
          <thead class="bg-gray-50">
            <tr>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Remark</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Entry Date</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Next Date</th>
            </tr>
          </thead>
          <tbody>
             <tr v-for="item in leadlists" :key="item.id" class="bg-white"> 
              
              <!-- <tr v-for="(item ,index)  in leadlists" :key="item.id"> -->
              <td class="px-4 py-2 text-sm text-gray-900">{{item.remark}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.iddate}}</td>
              <td class="px-4 py-2 text-sm text-gray-900">{{item.nextdate}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- end table -->

 <!-- end show data --------------------------------------------------------------------------------------------------->



          <div class="mt-7">
            <label for="tagname" class="form-label">Next Date *</label>
            <input type="date" v-model="leads.nextdate" class="form-input" id="first_input" autocomplete="off" required>
          </div>
  
          <div class="mt-7">
            <label for="tagname" class="form-label">Remark *</label>
            <input type="text" v-model="leads.remark" class="form-input" id="first_input" placeholder="Remark" autocomplete="off" required>
          </div>
  
          <div class="flex justify-end mt-7">
            <button @click="save_followup" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Edit Modal -->
  










    
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
    <!-- End Delete Modal -->

    <!-- <div class="form-container" v-if="invoice">
      <div class="form-header">
        <img src="logo.png" alt="Logo">
        <h2 class="form-title">Membership Contract</h2>
      </div>
    
      <div class="section">
        <div class="section-title">Contact Details</div>
        <div class="row">
          <div class="col-50">
            <div class="form-group">
              <label>Full Name:</label>
              <p>{{invoice.firstname}} {{invoice.lastname}}</p>
            </div>
            <div class="form-group">
              <label>Date of Birth:</label>
              <p>{{invoice.dob}}</p>
            </div>
            <div class="form-group">
              <label>Gender:</label>
              <p>{{invoice.gender}}</p>
            </div>
            <div class="form-group">
              <label>Contact Number:</label>
              <p>{{invoice.phonenumber}}</p>
            </div>
          </div>
          <div class="col-50">
            <div class="form-group">
              <label>Membership ID:</label>
              <p></p>
            </div>
            <div class="form-group">
              <label>Email:</label>
              <p>{{invoice.email}}</p>
            </div>
            <div class="form-group">
              <label>Address:</label>
              <p>{{invoice.address}}</p>
            </div>
            <div class="form-group">
              <label>Adhar Card No.:</label>
              <p>{{invoice.aadharno}}</p>
            </div>
          </div>
        </div>
      </div>
    
      <div class="section">
        <div class="section-title">Emergency Contact Details</div>
        <div class="form-group">
          <label>Contact Number:</label>
          <p>{{invoice.emergency}}</p>
        </div>
      </div>
    
    
      <div class="section">
        <div class="section-title">Membership Details</div>
        <div class="form-group">
          <label>Plan:</label>
          <p>{{invoice.name}}</p>
        </div>
        <div class="form-group">
          <label>Joining Date:</label>
          <p>{{invoice.startdate}}</p>
        </div>
        <div class="form-group">
          <label>End Date:</label>
          <p>{{invoice.enddate}}</p>
        </div>
        <div class="form-group">
          <label>Duration:</label>
          <p>{{invoice.packagedays}}</p>
        </div>
      </div>
    
      <div class="section">
        <div class="section-title">Member Consent</div>
        <p>
          I, {{invoice.firstname}} {{invoice.lastname}} have agreed to participate in the Physical Fitness Exercise Program conducted by DFC Gym. I take this session at my own risk and responsibility. I know and have been informed about the benefits of exercise, which include improved work capacity, cardiovascular efficiency, and flexibility.
          <br><br>
          I am aware of the risks involved in exercising, including but not limited to fatigue, nausea, and dizziness, discomfort in breathing, and related issues. I understand that doing exercises improperly may increase my risk of injury.
          <br><br>
          By signing this consent form, I accept the responsibility for my actions during the program.
        </p>
        <div class="form-group">
          <label>Member's Name:</label>
          <p>{{invoice.firstname}} {{invoice.lastname}}</p>
        </div>
        <div class="form-group">
          <label>Member's Signature:</label>
          <p></p>
        </div>
      </div>
      <div class="section">
        <div class="section-title">MANAGEMENT DISCLAIMER</div>
        <p>
          
1. The management reserves the right to admission.
2. Memberships are non-proprietary. No representations, written or oral, other than those contained in the rules are authorized by or binding upon the fitness club.
3. The management may at anytime modify timings of the fitness club. Intimation of any modifications and holidays will be made available to members through messages on the notice board.We reserve the prerogative to assume that all members read the notice board.
4. The management may introduce, discontinue or modify any facility, service, equipment, rules and regulations or rates of the fitness club without prior notice.
5. The management shall not be considered in default of its
obligations in the instance of natural calamities such as floods, earthquakes, tomadoes, hurricanes, storms and heavy rainfall as well as occurrences such as strikes, lockdown,war, riots or fire, etc. In case of such unforeseen exceptional circumstances, the management may also be forced to discontinue operations temporarily or permanently. Under such circumstances the management will not be liable to pay any refund or give any extension.
6. The fitness clubs participating in collateral membership, intra club transfer facility and loyalty program may change from time to time at the sole discretion of the management and without prior notice. On request, information of these changes will be available to members at the front desk.
7. The management will not be responsible for any personal injuries or accidents sustained by individuals in and around the premises. Individuals may use all the facilities at their own risk.
8. Members are responsible for their own belongings and are advised not to carry valuables to the club. The management will not be responsible for any loss or theft of personal belongings of members.
9. Members must not keep their personal belongings or locker keys with any staff member in the club. The management will not be responsible for any theft or loss resulting from such actions. 10. Parking/valet parking in and around the club premises is at the sole responsibility of members.
11. Membership fees and all other additional facility payments
collected including registration fees are non-refundable. We have a 'No Refund' policy.
12. Members must make all payments only at the front desk and in exchange for a valid receipt. Members are advised to retain that receipt for the entire duration of their membership. No disputes or arguments will be entertained without presenting a valid receipt. 13. Payment towards membership or services at the fitness club ensures the member the use of that service or membership for the duration bought as per the rules. The payment in no way guarantees the same staff throughout the period of usage of the service or membership. Change in staff does not entitle any member to a refund.
14. Memberships of those members not abiding by the rules or defaulting in any payment will be terminated without a refund. 15. Members must not carry or store any illegal items or arms and ammunitions in the club premises. The management will not be responsible for such actions.
16. We assume that members have read all rules and regulations governing the operations of the club.
17. Refrain from using abusive language, fighting or treating anyone disrespectfully. If a member is found treating anyone disrespectfully or whose actions are in any way detrimental or hurtful to the sentiments of other members or staff, the management may at its discretion, suspend or cancel the rights, privileges or membership of that individual without refunding the fees.
18. Smoking, consuming alcohol and chewing of beetle leaf or tobacco in the premises is strictly prohibited. Entering the fitness club premises under the influence of alcohol or any recreational drugs is strictly prohibited. If a member is found breaking this rule, the management may at its discretion, suspend or cancel the rights, privileges or membership of that individual without refunding the fees.
FITNESS AREA RULES
1. Sportswear is compulsory in the workout areas of the club. Clothing considered inappropriate by the management will be
prohibited.
2. Appropriate and clean sports footwear is mandatory in the workout areas of the club.
3. No food or drinks are allowed in the exercise areas with the exception of covered bottles.
4. Bags and other personal belongings must be left outside the exercise area and neatly kept in the changing rooms or the lockers provided.
5. Television sets are provided only for visual entertainment and they will be kept on mute at all times.
6. Members are advised not to carry mobile phones and other valuables on the workout areas and if they do, they do so at their own risk.
7. All members are requested to carry their exercise schedule cards and duly fill the same during their workouts. These must be put in the appropriate slot in the holder after use. Put the cards according to the 1st letter of your last name.
8. Weights must be handled with care and careless dropping of weights is prohibited. Repeated offences will lead to termination of membership without a refund.
9. Please allow our trainers to focus on their prime purpose - To correct your exercise technique and to motivate you .We request you to rack all weights back on the stands after use.
10. If a piece of equipment is malfunctioning, members must discontinue use and notify staff immediately.
11. The management reserves the right to stop any activity that may be hazardous to the safety of other members e.g. skipping
etc.
12. Members are requested to not ask for help from a staff member wearing a Personal training tag as this signifies that he/she is busy with Personal training.
13. To benefit maximum members, the workout area is divided into zones and separate trainers are allotted to each zone. Trainers may be moved from one zone to another at the discretion of the floor supervisor.
14. Members are requested to inform any staff member in case they experience any discomfort such as dizziness, pain, excessive sweating, shortness of breath, etc. immediately. A comprehensive first aid kit is available at the front desk. 15. In case there is a waiting list maintained for the use of cardio machines, members who put their names on the waiting list are requested to note that when their turn comes, the receptionist will wait for the member to avail his/her turn for a limited period of 2 minutes only. After the 2 minute waiting period the turn will be given to the next member in line. The member who has missed his/her turn will have to put his/her name again at the bottom of the list.
16. In order to maintain hygiene, it is compulsory to carry a napkin or a towel while working out. All equipment must be wiped clean after use.
17. Chalk for securing grip on free weights is not permitted. Locks on barbells must be used at all times.
18. All guidelines and directions provided by the trainers for use of equipment must be adhered to.
19. Members must stop or pause the treadmill before getting off even if it is for a short while.
20. Maximum time limit set by management for using cardio equipment must be strictly adhered to.
21. The temperature within the premises and the volume and type of music played would be maintained as per majority preference at the sole discretion of the management.

        </p>
        <div class="form-group">
          <label>Member's Signature:</label>
          <p></p>
        </div>
        <div class="form-group">
          <label>Date:</label>
          <p></p>
        </div>
      </div>
      <div class="footer">
        <p>&copy; FITRIUM GYM. All rights reserved.</p>
      </div>
    </div> -->

</template>


<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     userRole:localStorage.getItem('userRole'),
     deleteId: 0,
     invoice:null,
     productsList:[],
     subscriptionlist:[],
     leadlists:[],
     datatable:null,
     followup_list:[],


    leads:{
        nextdate:'',
        remark:'',
        lead_id:0,

    },

    selected_leadid:0,


    lead: { 
                
                name: '', 
                contact:'',
                address:'',
                gender:'',
                age:'',
                nextdate:'',
                remark:'',

            
            },

            subscription: { 
                
                membername:'',
                pkg_name:'',
                startdate:'',
                endate:'',
                   
                    },



 }
 }, 
methods:{
  getOnlyDate(date){
    
    try {
    if(date){
      var dateHere=date;
      return dateHere.split(' ')[0];
    }else
    return '';
      
    } catch (error) {
      alert(error);
    return '';
    }
    
  },
  navigateToPrintPage(memberId) {
    const url = `${window.location.origin}/#/invoice/print?id=${memberId}`;
    const newWindow = window.open(url, '_blank');
    
    // Ensure the new tab is opened before triggering print
    if (newWindow) {
      newWindow.focus();
    } else {
      alert("Popup blocked. Please allow popups for this site.");
    }
  },
  // invoicePrint(id) {
  //     axios.post(`/invoice/details/${id}`)
  //       .then(response => {
  //         // Assign the response data (invoice details) to the 'invoice' data property
  //         this.invoice = response.data;
  //         const invoiceUrl = `/invoice/view?memberid=${id}`;
  //         window.open(invoiceUrl, '_blank'); // Open the new page in a separate tab
  //     })
  //       .catch(error => {
  //         console.log('Error fetching invoice data: ' + error);
  //       });
  //   },
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
        
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
        this.leads.lead_id=item.id;
        axios.post('getleadbyid',{leadeid:item.id}).then(function (response) {
                  self.leadlists=response.data.leads;
                  console.log(self.leadlists);
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });
              
                    });;

                  axios.post('getleadbyview').then(function (response) {
                  self.leadlists=response.data.leads;
                  console.log(self.leadlists);
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    
              
                    });;



     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },


 save_package() {
             var self = this; 
             axios.post('addlead', this.lead)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                   
                     self.getBasics();
                     self.closeModal();
                
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },

         save_followup() {
             var self = this; 
             axios.post('addfollowup', this.leads)
                 .then(response => {
                     var msg = response.data.msg;
                     var isSuccess = response.data.status;
                    
                     self.getBasics();
                     self.closeModal();
                
                 })
                 .catch(error => {
                     console.log('Error on Authentication: ' + error);
                 });
         },




 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
       let type = this.$route.params.type;
       console.log(type);
         axios.post(`subscriptionlist/${type}`).then(function (response) {
                  self.subscriptionlist=response.data.subscription;
                  self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            "order": [[0, 'desc']],
                            dom: 'Bfrtip', 
                            buttons: [
                              {
                                extend: 'excelHtml5',
                                title: 'Excel',
                              },
                            ],
                          });
              
                    });
  }, 


 



            delete_category() {
                var self = this; 
                axios.post('deletesubscription', {deleteId:this.deleteId})
                    .then(response => {
                        self.subscriptionlist=response.data.subscription;
                        self.employees=response.data.userDetails; 
                         self.closeModal();
                         self.getBasics();
                        //  location.reload();
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
<style scoped>
  * {
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }

  body {
    background-color: #f3f3f3;
    padding: 20px;
  }

  .form-container {
    width: 800px;
    margin: auto;
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 20px;
  }

  .form-header {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-header img {
    width: 100px;
    margin-bottom: 10px;
  }

  .form-title {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
  }

  .section {
    margin-bottom: 15px;
  }

  .section-title {
    font-weight: bold;
    font-size: 18px;
    background-color: #000;
    color: #fff;
    padding: 5px;
    margin-bottom: 10px;
  }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .form-group label {
    flex: 0 0 200px;
    font-weight: bold;
  }

  .form-group input {
    flex: 1;
    padding: 5px;
    border: 1px solid #ddd;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-50 {
    width: 50%;
    padding: 0 10px;
  }

  .col-100 {
    width: 100%;
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
  </style>
